const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const TimerWrapper = require("../../core/view/TimerWrapper");
const OfficeModal = require("./OfficeModal");
const {ErrorIcon} = require("../../core/view/ErrorIcon");
const CopyTable = require("../../core/util/CopyTable");

const styles = require("./styles/UserRateLimitModal.css");

module.exports = createReactClass({
	displayName: "UserRateLimitModal",

	propTypes: {
		// Assumed not to change after mount
		initialSeconds: PT.number.isRequired,
	},

	onRefresh: function() {
		window.location.reload();
	},

	renderButton: function(left) {
		if (left > 0) {
			return <div className={styles.buttonDisabled}>{left}</div>;
		} else {
			return (
				<div className={styles.button} onClick={this.onRefresh}>
					Refresh
				</div>
			);
		}
	},

	renderModal: function(initialSeconds, left) {
		return (
			<OfficeModal
				cannotClose={true}
				portalContainer={null}
				level="warning"
				modalClass={styles.main}
			>
				<div className={styles.container}>
					<div className={styles.aboveButton}>
						<ErrorIcon />
						<div className={styles.message}>
							{CopyTable.forUserRateLimitModal(initialSeconds)}
						</div>
					</div>
					{this.renderButton(left)}
				</div>
			</OfficeModal>
		);
	},

	render: function() {
		return (
			<TimerWrapper
				initialSeconds={this.props.initialSeconds}
				render={this.renderModal}
			/>
		);
	},
});
